<script>
  import { ChevronDown } from 'lucide-svelte'
  import Tooltip from '@components/general/tooltip.svelte'
  import { cn } from '@lib/utils'

  let { open = $bindable(false), size = 12, hint, class: className = '', ...restProps } = $props()
</script>

<Tooltip {hint}>
  <ChevronDown {size} class={cn('transition-transform duration-200', open ? 'rotate-180' : '', className)} {...restProps} />
</Tooltip>